// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__p8Ou-","header":"PatientBlock_header__3EY55","label":"PatientBlock_label__3Dsp6","option":"PatientBlock_option__2Hee1"};